import { z } from 'zod';

/**
 * Request and response bodies of the worker's numbers API (`/api/workspaces/:id/numbers`). The
 * browser lists numbers straight from `phone_numbers` (RLS: every member reads); adding one goes
 * through the worker because it talks to the messaging provider.
 */

/** A North American area code (first digit 2–9). */
export const AreaCodeSchema = z
  .string()
  .trim()
  .regex(/^[2-9]\d{2}$/, 'Enter a 3-digit area code (it cannot start with 0 or 1)');

export const AddNumberRequestSchema = z.object({ areaCode: AreaCodeSchema });
export type AddNumberRequest = z.infer<typeof AddNumberRequestSchema>;

export const NUMBER_STATUSES = ['ordering', 'active', 'paused', 'released'] as const;
export type NumberStatus = (typeof NUMBER_STATUSES)[number];

export const AddNumberResponseSchema = z.object({
  id: z.uuid(),
  e164: z.string(),
  status: z.enum(NUMBER_STATUSES),
});
export type AddNumberResponse = z.infer<typeof AddNumberResponseSchema>;

/**
 * Fake numbers use the 555-01XX exchange, which the North American Numbering Plan reserves for
 * fiction in every area code, so a fake number can never be someone's real phone.
 */
export function isFictionalNumber(e164: string): boolean {
  return /^\+1[2-9]\d{2}55501\d{2}$/.test(e164);
}
